import { render, staticRenderFns } from "./AttrIClock.vue?vue&type=template&id=eda59406&scoped=true"
import script from "./AttrIClock.vue?vue&type=script&lang=js"
export * from "./AttrIClock.vue?vue&type=script&lang=js"
import style0 from "./AttrIClock.vue?vue&type=style&index=0&id=eda59406&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eda59406",
  null
  
)

export default component.exports